import { PerformanceEnum } from "../../../types/common";
import { ApiResponse } from "../../redux/types";
import request from "../request";
import {
  AvailableToPayRes,
  DashboardGraphResponse,
  DashboardPerformanceResponse,
  DashboardResponse,
} from "./types";

const getDashboardData = async () => {
  return await request.get<ApiResponse<DashboardResponse>>("/Dashboard/Get");
};

const getAvailableToPay = async () => {
  return await request.get<ApiResponse<AvailableToPayRes>>(
    "/Dashboard/AvailableToPay"
  );
};

const getDashboardPerformance = async (id: PerformanceEnum) => {
  return await request.get<ApiResponse<DashboardPerformanceResponse>>(
    `/Dashboard/Performance?range=${id}`
  );
};

const getDashboardGraphData = async (year: number) => {
  return await request.get<ApiResponse<DashboardGraphResponse>>(
    `/Dashboard/Graph?year=${year}`
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDashboardData,
  getAvailableToPay,
  getDashboardPerformance,
  getDashboardGraphData,
};
